import React from 'react';
import ReactMarkdown from 'react-markdown';

const MarkdownRenderer = ({ 
  content, 
  className='',
  components={}
}) => {
  const defaultComponents = {
    h1: ({ children }) => (
      <h1 className='text-2xl font-bold text-gray-900 mb-4'>{children}</h1>
    ),
    h2: ({ children }) => (
      <h2 className='text-xl font-semibold text-gray-800 mb-3'>{children}</h2>
    ),
    h3: ({ children }) => (
      <h3 className='text-lg font-medium text-gray-800 mb-2'>{children}</h3>
    ),
    p: ({ children }) => (
      <p className='text-gray-700 mb-3 leading-relaxed'>{children}</p>
    ),
    ul: ({ children }) => (
      <ul className='list-disc list-inside text-gray-700 mb-3 space-y-1'>{children}</ul>
    ),
    ol: ({ children }) => (
      <ol className='list-decimal list-inside text-gray-700 mb-3 space-y-1'>{children}</ol>
    ),
    li: ({ children }) => (
      <li className='ml-2'>{children}</li>
    ),
    blockquote: ({ children }) => (
      <blockquote className='border-l-4 border-gray-300 pl-4 italic text-gray-600 mb-3'>
        {children}
      </blockquote>
    ),
    code: ({ inline, children }) => {
      if (inline)
        return (
          <code className='bg-gray-100 text-gray-800 px-1 py-0.5 rounded text-sm font-mono'>
            {children}
          </code>
        );

      return (
        <pre className='bg-gray-100 p-3 rounded-lg overflow-x-auto mb-3'>
          <code className='text-sm font-mono text-gray-800'>{children}</code>
        </pre>
      );
    },
    strong: ({ children }) => (
      <strong className='font-semibold text-gray-900'>{children}</strong>
    ),
    em: ({ children }) => (
      <em className='italic text-gray-700'>{children}</em>
    ),
    a: ({ href, children }) => (
      <a 
        href={href} 
        className='text-blue-600 hover:text-blue-800 underline'
        target='_blank'
        rel='noopener noreferrer'
      >
        {children}
      </a>
    ),
    table: ({ children }) => (
      <div className='overflow-x-auto mb-3'>
        <table className='min-w-full border border-gray-200 rounded-lg'>
          {children}
        </table>
      </div>
    ),
    thead: ({ children }) => (
      <thead className='bg-gray-50'>{children}</thead>
    ),
    tbody: ({ children }) => (
      <tbody className='divide-y divide-gray-200'>{children}</tbody>
    ),
    tr: ({ children }) => (
      <tr className='hover:bg-gray-50'>{children}</tr>
    ),
    th: ({ children }) => (
      <th className='px-4 py-2 text-left text-sm font-medium text-gray-900 border-b border-gray-200'>
        {children}
      </th>
    ),
    td: ({ children }) => (
      <td className='px-4 py-2 text-sm text-gray-700'>{children}</td>
    ),
    hr: () => (
      <hr className='border-gray-300 my-4' />
    ),
    ...components
  };

  if (!content) return;

  return (
    <div className={`prose prose-sm max-w-none ${className}`}>
      <ReactMarkdown
        components={defaultComponents}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
